import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Button } from './Button';
import { Loader } from './Loader';

export const SubmitButton = forwardRef(({ title, isLoading, children, style, ...otherProps }, ref) => {
    const buttonRef = useRef();
    const [disabled, setDisabled] = useState(false);

    useImperativeHandle(ref, () => ({
        setDisabled // exposes setDisabled to the incoming ref
    }));

    return (
        <Button
            buttonRef={buttonRef}
            disabled={disabled}
            style={{ ...style, pointerEvents: isLoading ? 'none' : undefined, position: 'relative' }}
            title={disabled ? title : null}
            type='submit'
            variant='solid'
            {...otherProps}
        >
            <span style={{ visibility: isLoading ? 'hidden' : 'inherit' }}>
                {children}
            </span>
            {isLoading && (
                <span style={{ alignItems: 'center', bottom: 0, display: 'flex', justifyContent: 'center', left: 0, position: 'absolute', right: 0, top: 0 }}>
                    <Loader size={4} />
                </span>
            )}
        </Button>
    );
});

SubmitButton.displayName = 'SubmitButton';
